module.exports = {"140213001":"南关街道","140213002":"北关街道","140213003":"东街街道","140213004":"西街街道","140213005":"南街街道","140213006":"北街街道","140213007":"新建南路街道","140213008":"新建北路街道","140213009":"大庆路街道","140213010":"新华街街道","140213011":"向阳里街道","140213012":"振华南街街道","140213013":"开源街街道","140213201":"新旺乡","140213202":"水泊寺乡","140213203":"马军营乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140213.json
// module id = 274
// module chunks = 0